import { render, staticRenderFns } from "./SupportContact.vue?vue&type=template&id=6ae66dde&scoped=true"
import script from "./SupportContact.vue?vue&type=script&lang=js"
export * from "./SupportContact.vue?vue&type=script&lang=js"
import style0 from "./SupportContact.vue?vue&type=style&index=0&id=6ae66dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae66dde",
  null
  
)

export default component.exports